import { render, staticRenderFns } from "./OrderPage.vue?vue&type=template&id=a52a26b2"
import script from "./OrderPage.vue?vue&type=script&lang=js"
export * from "./OrderPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports